define('views/search-form',[
  // These are path alias that we configured in our bootstrap
  'jquery', 'underscore', 'backbone', 'classes/templator'],
  function($, _, Backbone, templator){

  return Backbone.View.extend({

    events: {
      'click #sf-more-search-options-btn': 'handleDropdown',
      'click #sf-search-btn': 'submit',
      'input #sf-location': 'search',
      'click #sf-suggestions > li': 'suggestionSelected',
      'touchstart #sf-suggestions > li': 'suggestionSelected',
      'mousemove #sf-suggestions > li': 'suggestionHovered',
      'focus #sf-location': 'scrollLocationTop',
      'click #sf-clear': 'clearLocation',
      'click #where-near-me': 'geoLocate'
    },

    initialize: function(options) {

      this.mobile = options.mobile || false;
      this.has_coords = this.mobile && !_.isEmpty(this.$('#sf-lat').val());

      if (this.mobile && (
          typeof navigator == 'undefined' ||
          typeof navigator.geolocation == 'undefined' ||
          typeof navigator.geolocation.getCurrentPosition != 'function'
        )
      )
      {
        this.geoDenied();
      }

      this.visible = false;
      this.initial_top = parseInt(this.$el.css('top').slice(0, -2));
      this.search_form_bottom_height = this.mobile ?
        0 :
        parseInt(this.$('#sf-search-form-bottom').css('height').slice(0, -2));
      this.search_id = (!_.isEmpty(this.$('#search_id').val())) ? this.$('#search_id').val() : null;
      this.search_type = (!_.isEmpty(this.$('#search_tpye').val())) ? this.$('#search_type').val() : null;

      // this.on('load_location', this.loadLocation);
      this.ajax_request = null;
      this.template = templator.suggestions;
      this.$suggestions = this.$('#sf-suggestions');
      this.$input = this.$('#sf-location');

      this.setupEvents();

      if (this.hasSearch()) {
        this.$el.find('#sf-more-search-options-btn').click();
      }

      $('i.glyphicon').tooltip({placement: 'top'});
    },

    search: function() {
      var search = this.$input.val(),
          this_ = this;
      // this.$suggestions.hide();
      if (search.length > 2) {
        this.startRequest();
        this.ajax_request = $.ajax({
          type: 'GET',
          url: '/locations',
          data: {
            name: search
          },
          success: function(resp) {
            if (resp.length) {
              var html = this_.template({search: search, results: resp});
              this_.$suggestions.html(html).show();
            }
            else {
              this_.hideSuggestions();
              this.search_id = null;
            }
          },
          complete: function() {
            this_.endRequest();
          },
          dataType: 'json'
        });
      }
    },

    startRequest: function() {
      if (this.ajax_request) {
        this.ajax_request.abort();
      }
      this.$input.addClass('loading');
    },

    endRequest: function() {
      this.$input.removeClass('loading');
      this.ajax_request = null;
    },

    handleDropdown: function(e) {
      e.preventDefault();
      var $div = this.$('#sf-search-form-bottom'),
          $button = $(e.target);
      if (this.visible) {
        $div.slideUp();
        this.$el.animate({top: this.initial_top + 'px'});
        $button.html('&#x25BE;&nbsp;&nbsp;More options');
        this.visible = false;
      }
      else {
        $div.slideDown();
        this.$el.animate({top: (this.initial_top - Math.round(this.search_form_bottom_height / 2) + 'px')});
        $button.html('&#x25B4;&nbsp;&nbsp;Hide options');
        this.visible = true;
      }
      if (this.mobile) {
        this.reAnyStretch();
      }
    },

    loadSearch: function(search) {
      var search = search.data();
      this.search_id = search.id;
      this.$('#search_id').val(search.id);
      this.$('#search_type').val(search.type);
      this.$input.val(search.name).blur();
    },

    submit: function(e) {
      if (typeof e !== 'undefined') {
        e.preventDefault();
      }
      if (this.search_id == null && !this.has_coords) {
        this.showError();
      }
      else {
        var this_ = this;
        $(window).unload(function() {
          // need to do this for when suer hits 'back' button and form is cached
          this_.$('#sf-search-btn').attr('disabled',false);
        });
        this.hideError();
        this.$('#sf-search-btn').attr('disabled', 'disabled'); // <-| undoes this
        this.$('form').submit();
      }
    },

    setupEvents: function() {
      var this_ = this;
      $(document).keydown(function(e){
        if (!this_.$suggestions.is(':visible')) {
          return;
        }
        var $items = this_.$suggestions.find('li'),
            count = $items.length,
            $selectedLi = $items.filter('.selected');

        switch (e.keyCode) {
          case 38: // up arrow
            e.preventDefault();
            if ($selectedLi.length) {
              $selectedLi.removeClass('selected').loopPrev().addClass('selected');
            } else {
              $items.eq(count - 1).addClass('selected');
            }
            break;
          case 40: // down arrow
            e.preventDefault();
            if ($selectedLi.length) {
              $selectedLi.removeClass('selected').loopNext().addClass('selected');
            } else {
              $items.eq(0).addClass('selected');
            }
            break;
          case 27: // ESC
            this_.hideSuggestions();
            break;
          case 13: // Enter
            e.preventDefault();
            if ($selectedLi.length) {
              this_.suggestionSelected();
            }
            else {
              this_.hideSuggestions();
              this_.submit(e);
            }
            break;
          case 46: // baskpace
          case 8: // delete
            if (this_.$input.val().length < 3) {
              this_.hideSuggestions();
            }
            break;
        }
      }).click(function(event) {
        var $target = $(event.target);
        if ($target.attr('id') != 'sf-suggestions' && $target.parents('#sf-suggestions').length == 0 && this_.$suggestions.is(':visible')) {
          this_.hideSuggestions();
        }
      });
    },

    suggestionSelected: function(e) {
      var $selected;
      if (this.mobile) {
        e.preventDefault();
        e.stopPropagation();
        $selected = $(e.currentTarget);
      }
      else {
        $selected = this.$('li.selected');
      }
      this.hideSuggestions();
      this.loadSearch($selected);
      this.hideError();
      this.submit();
    },

    suggestionHovered: function(elem) {
      this.$('li.selected').removeClass('selected');
      $(elem.currentTarget).addClass('selected');
    },

    hideSuggestions: function() {
      this.$suggestions.hide();
    },

    hasSearch: function() {
      var regex = /^\/restaurants\/[a-zA-Z0-9-]+\-\d+\/[a-zA-Z-]+/,
          search = window.location.search;
      if (search.length) {
        search = search.substr(1).replace(/order_by=\d+/, '');
        search = search.replace(/removed=\d+/, '');
      }
      return search.length > 0 || !this.mobile && regex.test(window.location.pathname);
    },

    showError: function() {
      this.$('#sf-search-error').show();
      this.$('input[type="text"]').addClass('error').focus();
      if (this.mobile) {
        this.reAnyStretch();
      }
    },

    hideError: function() {
      this.$('#sf-search-error').hide();
      this.$('input[type="text"]').removeClass('error');
      if (this.mobile) {
        this.reAnyStretch();
      }
    },

    geoLocate: function() {
      if (!this.has_coords) {
        var this_ = this,
            $btn = this.$('#sf-search-btn');
        navigator.geolocation.getCurrentPosition(
          function(position) {
            this_.$('#sf-lat').val(position.coords.latitude);
            this_.$('#sf-lon').val(position.coords.longitude);
            this_.has_coords = true;
          },
          function() {
            this_.geoDenied('Location access denied. Please search by location or restaurant instead');
          }
        );
      }
    },

    geoDenied: function(message) {
      if (typeof message !== 'undefined') {
        alert(message);
      }
      var this_ = this;
      this.$('#sf-radios').slideUp(function() {
        this_.$input.focus();
        this_.reAnyStretch();
      });
    },

    clearLocation: function() {
      this.$input.val('').focus();
      this.$('#search_id').val('');
      this.$('#search_type').val('');
      this.search_type = this.search_id = null;
    },

    scrollLocationTop: function() {
      this.$('#where-specify').click();
      if (this.mobile && $('#hp-search').length) {
        $(document).scrollTo('#sf-location', 400, {offset: -130});
      }
    },

    reAnyStretch: function() {
      if (typeof background_img != 'undefined') {
        setTimeout(function() { $('#hp-search-outer').anystretch(background_img, {speed: 500});}, 300);
      }
    }

  });

});
